export default __webpack_public_path__ + "static/client_img1-dd7ee0371c995aa5b39b54f9e3222d7d.webp";